// This file is generated by a script. Do not edit this file directly.
var _excluded = ["icon"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
import * as icons from "../icons";
export var Icon = function Icon(_ref) {
  var icon = _ref.icon,
    props = _objectWithoutProperties(_ref, _excluded);
  var IconComponent = icons[icon];
  if (!IconComponent) return null;
  return /*#__PURE__*/React.createElement(IconComponent, props);
};
